module.exports = __webpack_public_path__ + "store/img/optInImage-us.88a6e75e.png";